/*
 * Mega-grow: naglowek "OD ZDJECIA DO BIZUTERII" rosnie ze scrolla jako
 * bezposrednie wejscie do sekcji "Jak to dziala".
 *
 * Mechanika wzorowana na C:\AI_FACTORY\web\generated_sites\prawnik\
 * subarchetyp\corporate\animations-editorial.js (initMegaGrow): skala jest
 * funkcja aktualnej pozycji wrappera wzgledem viewportu
 * (getBoundingClientRect), NIE triggerem "wszedl w pole widzenia" - scroll
 * w gore cofa efekt 1:1, tak samo plynnie jak go zbudowal.
 *
 * OSTROSC TEKSTU: tekst jest renderowany w CSS od razu w rozmiarze
 * KONCOWYM, a my skalujemy go 0.5 -> 1. Wzrost jest wciaz dokladnie
 * dwukrotny, ale stan koncowy to natywny rendering fontu, nie raster
 * rozciagniety 2x. Skalowanie w dol nie gubi jakosci, w gore - gubi.
 *
 * Stan bez JS / przy prefers-reduced-motion: CSS nie ustawia zadnego
 * transformu, wiec naglowek stoi w pelnym rozmiarze i jest w pelni ostry.
 */
(() => {
  const wraps = document.querySelectorAll('[data-mega-grow]');
  if (!wraps.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const START_SCALE = 0.5; // 0.5 -> 1 to ten sam wzrost co 1 -> 2
  const clamp01 = (value) => Math.min(1, Math.max(0, value));

  wraps.forEach((wrap) => {
    const text = wrap.querySelector('[data-mega-text]');
    if (!text) return;

    let ticking = false;
    let active = false;

    const render = () => {
      const rect = wrap.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      // Progres jest zaczepiony o srodek naglowka i rozegrany w pasie, w
      // ktorym naglowek jest REALNIE widoczny: start, gdy jego srodek jest
      // na 85% wysokosci ekranu (tuz po wejsciu), koniec - gdy dojdzie do
      // 25% (wciaz na ekranie). Gdyby liczyc od krawedzi viewportu, oba
      // skrajne stany - 0.5 i 1 - wypadalyby poza ekranem i uzytkownik
      // widzialby tylko srodek zakresu.
      const center = rect.top + rect.height / 2;
      const from = viewportHeight * 0.85;
      const to = viewportHeight * 0.25;
      const progress = clamp01((from - center) / (from - to));

      const scale = START_SCALE + progress * (1 - START_SCALE);
      const shiftX = progress * -14;
      const shiftY = progress * -10;
      text.style.transform = `translate(${shiftX}px, ${shiftY}px) scale(${scale})`;
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(render);
    };

    // IntersectionObserver gate'uje listener scrolla - odczyt pozycji
    // dzieje sie tylko wtedy, gdy sekcja jest blisko viewportu.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !active) {
          active = true;
          window.addEventListener('scroll', requestUpdate, { passive: true });
          window.addEventListener('resize', requestUpdate, { passive: true });
          requestUpdate();
        } else if (!entry.isIntersecting && active) {
          active = false;
          window.removeEventListener('scroll', requestUpdate);
          window.removeEventListener('resize', requestUpdate);
        }
      });
    }, { rootMargin: '40% 0px 40% 0px', threshold: 0 });

    // W nieaktywnej karcie requestAnimationFrame nie biegnie, wiec po
    // powrocie do karty przeliczamy stan od razu, bez czekania na scroll.
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && active) render();
    });

    observer.observe(wrap);
    render();
  });
})();
